import { Dictionary } from "../../domain/dictionary";
import {
  Expression,
  EvaluateOptions,
  ParameterArgs,
  FunctionArgs,
  EvaluateParameterHandler,
} from "ncalcjs";
import { IapExpression } from "../../domain/iapExpression";
import { IapExpressionDetail } from "../../domain/iapExpressionDetail";
import HelperUtils from "../../../../../common/infrastructure/funciones/HelperUtils";
import HelperCommon from "../../../../../common/infrastructure/funciones/HelperCommon";
import { MessageService } from "../../../../../common/infrastructure/servicios";
import { MessageType } from "../../../../../common/infrastructure/servicios/MessageService";

export abstract class ExpresionEngine {
  public static resolveExpression(
    inputExpresion: string,
    data: Dictionary<String, Object>[]
  ): any {    
    const e = new Expression(inputExpresion, EvaluateOptions.RoundAwayFromZero);
    if (e.HasErrors()) {
      console.error("Error en expresión" + inputExpresion);
      console.log(e.errors);
    }
    data?.forEach((param) => {
      e.EvaluateParameter[param.key as any] = (arg: ParameterArgs) => {
        arg.Result =
          data.find((x) => x.key == param.key)?.value ?? null;
      };
    });

    e.EvaluateFunction["getPropertyValue"] = (args: FunctionArgs) => {      
      args.Result ='';
      if (args.Parameters.length == 3) {
        try {
          const obj = args.Parameters[0].Evaluate();
          const field = args.Parameters[1].Evaluate()?.toString();
          const key = args.Parameters[2].Evaluate()?.toString();
          const reg = obj.find((x: any) => x.campo == field)
          if (reg){
            args.Result =reg[key];
          }
          
        } catch {}
      }
      
    };
    e.EvaluateFunction["falso"] = (args: FunctionArgs) => {
      args.Result = false;
    };
    e.EvaluateFunction["verdadero"] = (args: FunctionArgs) => {
      args.Result = true;
    };

    e.EvaluateFunction["tamcadena"] = (args: FunctionArgs) => {
      args.Result = "";
      if (args.Parameters.length == 1) {
        try {
          const cadena = args.Parameters[0].Evaluate().toString();

          args.Result = cadena.Length;
        } catch {}
      }
    };

    e.EvaluateFunction["subcadena"] = (args: FunctionArgs) => {
      args.Result = "";
      if (args.Parameters.length == 2 || args.Parameters.length == 3) {
        try {
          const cadena = args.Parameters[0].Evaluate().toString();

          let initpos = parseInt(args.Parameters[1].Evaluate().ToString());
          let finpos = cadena.Length;
          if (args.Parameters.length == 3) {
            finpos = parseInt(args.Parameters[2].Evaluate().ToString());
            if (finpos >= 0) args.Result = cadena.substring(initpos, finpos);
          } else if (args.Parameters.length == 2) {
            args.Result = cadena.substring(initpos);
          }
        } catch {}
      }
    };

    e.EvaluateFunction["guid"] = (args: FunctionArgs) => {
      args.Result = HelperUtils.newGuid();
    };

    e.EvaluateFunction["yeardiff"] = (args: FunctionArgs) => {
      args.Result = false;
      if (args.Parameters.length < 2) {
        args.Result = 0;
      } else {
        try {
          const dt1 = new Date(args.Parameters[0].Evaluate().toString());
          const dt2 = new Date(args.Parameters[1].Evaluate().toString());
          var diff = (dt2.getTime() - dt1.getTime()) / 1000;
          diff /= 60 * 60 * 24;
          const dd = Math.abs(Math.round(diff / 365.25));
          args.Result = dd;
        } catch {
          args.Result = 0;
        }
      }
    };

    e.EvaluateFunction["monthdiff"] = (args: FunctionArgs) => {
      args.Result = false;
      if (args.Parameters.length < 2) {
        args.Result = 0;
      } else {
        try {
          const dt1 = new Date(args.Parameters[0].Evaluate().toString());
          const dt2 = new Date(args.Parameters[1].Evaluate().toString());
          const monthDiff = dt1.getMonth() + 1 - (dt2.getMonth() + 1);
          const yearDiff = dt1.getFullYear() - dt2.getFullYear();

          const dd = monthDiff + yearDiff * 12;
          args.Result = dd;
        } catch {
          args.Result = 0;
        }
      }
    };

    e.EvaluateFunction["daydiff"] = (args: FunctionArgs) => {
      args.Result = false;
      if (args.Parameters.length < 2) {
        args.Result = 0;
      } else {
        try {
          const dt1 = new Date(args.Parameters[0].Evaluate().toString());
          const dt2 = new Date(args.Parameters[1].Evaluate().toString());
          // To calculate the time difference of two dates
          const Difference_In_Time = dt2.getTime() - dt1.getTime();

          // To calculate the no. of days between two dates
          const dd = Difference_In_Time / (1000 * 3600 * 24);
          args.Result = dd;
        } catch {
          args.Result = 0;
        }
      }
    };

    e.EvaluateFunction["convertirmoneda"] = (args: FunctionArgs) => {
      args.Result = 0.0;
      if (args.Parameters.length < 1) {
        args.Result = 0.0;
      } else {
        try {
          const inputResu = args.Parameters[0].Evaluate();

          try {
            args.Result = parseFloat(inputResu?.toString());
          } catch {
            const defaultResu = args.Parameters[1].Evaluate();
            try {
              args.Result = parseFloat(defaultResu?.tostring());
            } catch {
              args.Result = 0.0;
            }
          }
        } catch {
          args.Result = 0.0;
        }
      }
    };

    e.EvaluateFunction["convertirnumero"] = (args: FunctionArgs) => {
      args.Result = 0;
      if (args.Parameters.length < 1) {
        args.Result = 0;
      } else {
        try {
          const inputResu = args.Parameters[0].Evaluate();

          try {
            args.Result = parseInt(inputResu?.toString());
          } catch {
            const defaultResu = args.Parameters[1].Evaluate();
            try {
              args.Result = parseInt(defaultResu?.tostring());
            } catch {
              args.Result = 0;
            }
          }
        } catch {
          args.Result = 0;
        }
      }
    };

    e.EvaluateFunction["in"] = (args: FunctionArgs) => {
      args.Result = false;
      if (args.Parameters.length < 2) {
        args.Result = true;
      } else {
        try {
          var inputResu = args.Parameters[0].Evaluate();
          let Lista = new Array<Object>();

          for (var i = 1; i <= args.Parameters.length - 1; i++) {
            const aux = args.Parameters[i].Evaluate()?.ToString();
            if (!HelperCommon.isNullOrWhitespace(aux)) {
              Lista.push(aux);
            }
          }

          args.Result = Lista.includes(inputResu);
        } catch {}
      }
    };

    e.EvaluateFunction["rango"] = (args: FunctionArgs) => {
      // TODO por hacer
      args.Result = "";
    };

    e.EvaluateFunction["addday"] = (args: FunctionArgs) => {
      if (args.Parameters.length < 2) {
        args.Result = 0;
      }
      try {
        const total = parseInt(args.Parameters[1].Evaluate()?.toString());
        const dd = new Date(args.Parameters[0].Evaluate()?.toString());
        args.Result = dd.setDate(dd.getDate() + total);
      } catch {
        args.Result = 0;
      }
    };

    e.EvaluateFunction["addyear"] = (args: FunctionArgs) => {
      if (args.Parameters.length < 2) {
        args.Result = 0;
      }
      try {
        const total = parseInt(args.Parameters[1].Evaluate()?.toString());
        const dd = new Date(args.Parameters[0].Evaluate()?.toString());
        args.Result = dd.setFullYear(dd.getFullYear() + total);
      } catch {
        args.Result = 0;
      }
    };

    e.EvaluateFunction["addmonth"] = (args: FunctionArgs) => {
      if (args.Parameters.length < 2) {
        args.Result = 0;
      }
      try {
        const total = parseInt(args.Parameters[1].Evaluate()?.toString());
        const dd = new Date(args.Parameters[0].Evaluate()?.toString());
        args.Result = dd.setMonth(dd.getMonth() + total);
      } catch {
        args.Result = 0;
      }
    };

    e.EvaluateFunction["getday"] = (args: FunctionArgs) => {
      if (args.Parameters.length < 1) {
        args.Result = 0;
      }
      try {
        args.Result = new Date(
          args.Parameters[0].Evaluate()?.toString()
        ).getUTCDate();
      } catch {
        args.Result = 0;
      }
    };

    e.EvaluateFunction["getyear"] = (args: FunctionArgs) => {
      if (args.Parameters.length < 1) {
        args.Result = 0;
      }
      try {
        args.Result = new Date(
          args.Parameters[0].Evaluate()?.toString()
        ).getFullYear();
      } catch {
        args.Result = 0;
      }
    };

    e.EvaluateFunction["getmonth"] = (args: FunctionArgs) => {
      if (args.Parameters.length < 1) {
        args.Result = 0;
      }
      try {
        args.Result =
          new Date(args.Parameters[0].Evaluate()?.toString()).getMonth() + 1;
      } catch {
        args.Result = 0;
      }
    };

    e.EvaluateFunction["catalogo"] = (args: FunctionArgs) => {
      // TODO por hacer
      args.Result = "";
    };

    e.EvaluateFunction["edad"] = (args: FunctionArgs) => {
      const dateString = args.Parameters[0].Evaluate()?.toString();
      const hoy = new Date();
      const fechaNacimiento = new Date(dateString);
      let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
      const diferenciaMeses = hoy.getMonth() - fechaNacimiento.getMonth();
      if (
        diferenciaMeses < 0 ||
        (diferenciaMeses === 0 && hoy.getDate() < fechaNacimiento.getDate())
      ) {
        edad--;
      }
      args.Result = edad;
    };

    e.EvaluateFunction["msg"] = (args: FunctionArgs) => {
      var inputResu = args.Parameters[0].Evaluate();
      args.Result = inputResu?.toString();
    };


    e.EvaluateFunction["convertstring"] = (args: FunctionArgs) => {
      var inputResu = args.Parameters[0].Evaluate();
      args.Result = inputResu?.toString();
    };

    e.EvaluateFunction["setvalues"] = (args: FunctionArgs) => {
      // TODO por hacer
      args.Result = "";
    };

    e.EvaluateFunction["hoy"] = (args: FunctionArgs) => {
      // TODO
      //args.Result = "";
      args.Result = new Date().toLocaleDateString("es-ES");
      /*
                        if (args.Parameters.length == 1)
                        {
                            let num = parseInt(inputResu.toString().toLowerCase().substring(0, inputResu.toString().Length - 1));
                            var inputResu = args.Parameters[0].Evaluate();
                            if (int.TryParse(inputResu.ToString().ToLower().Substring(0, inputResu.ToString().Length - 1), out num))
                            {
                                const opcion = inputResu.ToString().ToLower().Substring(inputResu.ToString().Length - 1);
                                switch (opcion.ToLower())
                                {
                                    case "d":
                                        args.Result = DateTime.Parse(DateTime.Now.AddDays(num).ToShortDateString());
                                        break;
                                    case "m":
                                        args.Result = DateTime.Parse(DateTime.Now.AddMonths(num).ToShortDateString());
                                        break;
                                    case "y":
                                    case "a":
                                        args.Result = DateTime.Parse(DateTime.Now.AddYears(num).ToShortDateString());
                                        break;
                                }
                            }
                            else
                            {
                                string opcion = inputResu.ToString().ToLower().Substring(inputResu.ToString().Length - 1);
                                switch (opcion.ToLower())
                                {
                                    case "d":
                                        args.Result = DateTime.Now.Day.ToString();
                                        break;
                                    case "m":
                                        args.Result = DateTime.Now.Month.ToString();
                                        break;
                                    case "y":
                                    case "a":
                                        args.Result = DateTime.Now.Year.ToString();
                                        break;
                                }
                            }
                        }
                        */
    };

    /*
    
    e.EvaluateFunction["XXXXXXXXX"] = (args: FunctionArgs) => {
      // TODO por hacer
      args.Result = "";
      
    };


    */
    //e.EvaluateParameter

    /*e.EvaluateParameter =  function (key:string,args: ParameterArgs) : EvaluateParameterHandler {
            args.Result = 3.14
          };
          e.EvaluateParameter['x'] = (arg: ParameterArgs) => {
            arg.Result = 1;
        };
        */
    /*const cosa='a'
        e.EvaluateParameter[cosa] = (arg: ParameterArgs) => {
            arg.Result = 1;

        e.EvaluateFunction['SecretOperation'] = (args: FunctionArgs) => {
            args.Result = args.Parameters[0].Evaluate() + args.Parameters[1].Evaluate();
          };
      return "World";
      */

    try {
      const resulExp = e.Evaluate();  
      
      return resulExp;
    } catch (err: any) {      
        MessageService.showMessage(MessageType.Error, '', 'Ha ocurrido un error al resolver la expresión: "' + inputExpresion + '".Error:' + e?.errors?.map( (x:any)=> x.toString()).join('##ERRDET##'), true);
    }
    return null;
  }

  public static resolveExpressions(
    inputExpresions: IapExpressionDetail[],
    data: Dictionary<String, Object>[]
  ): any {
    let resu: any;

    let dic = JSON.parse(JSON.stringify(data));

    inputExpresions
      .sort((a, b) => {
        return a.processOrder - b.processOrder;
      })
      .forEach((exp) => {
        resu = this.resolveExpression(exp.expression, dic);
        var aux = {
          key: exp.variable,
          value: resu,
        };
        dic.push(aux as any);
      });

    return resu;
  }
}
